import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation, useHistory } from 'react-router-dom';
import { postUserRepresentativeSelfcareJwt } from '../../../actions/referent-api';
import { useDispatch, useSelector } from 'react-redux';
import * as R from 'ramda';
import { RegexFields } from '../../../constants/utils/regexFields';
import * as loadings from '../../../constants/loadings/referent';


import terms from './../../../assets/images/svg/054-terms.svg';

export const Password = () => {
    const passwordForm = useRef();
    const location = useLocation();
    const referent = useSelector(state => state.referent);
    const dispatch = useDispatch();
    const history = useHistory();

    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfPassword, setShowConfPassword] = useState(false);
    const [passwordRequirements, setPasswordRequirements] = useState({ hasLower: false, hasUpper: false, hasDigits: false });
    const [passwordsMatch, setPasswordsMatch] = useState(false);

    const [password, setPassword] = useState({
        newPass: '',
        confPass: '',
        passwordMatch: false
    });

    useEffect(() => {
        if (!R.isNil(password.newPass)) {
            let hasUpper = !R.isNil(password.newPass.match(RegexFields.hasUpperCase));
            let hasLower = !R.isNil(password.newPass.match(RegexFields.hasLowerCase));
            let hasDigits = !R.isNil(password.newPass.match(RegexFields.hasDigits));
            setPasswordRequirements({ ...passwordRequirements, hasDigits: hasDigits, hasLower: hasLower, hasUpper: hasUpper });
        }
        setPasswordsMatch(password.newPass === password.confPass);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [password]);

    return (
        <form className="flex-column mt-4 mb-auto h-inherit" ref={passwordForm} noValidate>
            <header className="block mb-4 pr-3">
                <h1 className="h1 text-primary font-weight-bolder mb-2">Définition de votre mot de passe</h1>
                <p className="o-80 mb-1">Afin de pouvoir accéder à votre espace référent, veuillez définir un mot de passe.</p>
                <p className="o-60 fs-3">Pour les connexions ultérieures, vous pourrez vous connecter en utilisant votre adresse e-mail ou numéro de téléphone ainsi que le mot de passe renseigné ci-dessous.</p>
            </header>
            <section className="block mb-auto">
                <div className="container-wide overflow-hidden">
                    <div className="row gx-2">
                        <div className="col-12 col-xl-auto">
                            <div className="form-group">
                                <label className="h6 font-weight-bolder" htmlFor="email">Nouveau mot de passe</label>
                                <div className="input-group">
                                    <input required minLength={8} maxLength={32} type={showNewPassword === false ? "password" : ''} className="form-control" id="password" placeholder="saisissez mot de passe" onInput={
                                        (event) => {
                                            event.preventDefault();
                                            setPassword({ ...password, newPass: event.target.value });
                                        }
                                    } />
                                    <div className="input-group-prepend">
                                        <div className={"input-group-text border-left-0 rounded-right dropdown"}>
                                            <i className={"eva o-30 fs-root lh-0 " + (showNewPassword === false ? 'eva-eye' : 'eva eva-eye-off')} role="button" id="showNewPassword" onClick={() => { setShowNewPassword(!showNewPassword); }}></i>
                                        </div>
                                    </div>
                                    <div className={"invalid-feedback"}>Mot de passe invalide</div>
                                </div>
                            </div>
                            <div className="form-group">
                                <label className="h6 font-weight-bolder" htmlFor="email">Confirmer le mot de passe</label>
                                <div className="input-group">
                                    <input required minLength={8} maxLength={32} type={showConfPassword === false ? "password" : ''} className="form-control" id="password-repeat" placeholder="saisissez mot de passe" onInput={
                                        (event) => {
                                            event.preventDefault();
                                            setPassword({ ...password, confPass: event.target.value });
                                        }
                                    } />
                                    <div className="input-group-prepend">
                                        <div className={"input-group-text border-left-0 rounded-right dropdown"}>
                                            <i className={"eva o-30 fs-root lh-0 " + (showConfPassword === false ? 'eva-eye' : 'eva eva-eye-off')} role="button" id="showConfPassword" onClick={() => { setShowConfPassword(!showConfPassword); }}></i>
                                        </div>
                                    </div>
                                    <div className={"invalid-feedback"}>Mot de passe invalide</div>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="card alert-info text-body rounded">
                                <div className="card-body p-3 d-flex align-items-start">
                                    <i className="eva eva-info text-info mr-2 h3 mt-n1"></i>
                                    <div className="flex-grow-1">
                                        <h1 className="small font-weight-bolder text-info text-uppercase">Pour un mot de passe plus sûr</h1>
                                        <p className="small o-50 lh-copy mb-1">Pour atteindre le niveau de sécurité requis, votre mot de passe doit comporter entre 8 et 32 caractères et inclure au moins 3 des types de caractères suivants:</p>
                                        <div role="button" className={"d-flex align-items-center small" + (passwordRequirements.hasUpper ? '' : ' o-50')}>
                                            <i className={"eva eva-checkmark-circle-outline mr-2" + (passwordRequirements.hasUpper ? ' text-success' : '')}></i>
                                            <span>une lettre majuscule (A-Z)</span>
                                        </div>
                                        <div role="button" className={"d-flex align-items-center small" + (passwordRequirements.hasLower ? '' : ' o-50')}>
                                            <i className={"eva eva-checkmark-circle-outline mr-2" + (passwordRequirements.hasLower ? ' text-success' : '')}></i>
                                            <span>une lettre minuscule (a-z)</span>
                                        </div>
                                        <div role="button" className={"d-flex align-items-center small" + (passwordRequirements.hasDigits ? '' : ' o-50')}>
                                            <i className={"eva eva-checkmark-circle-outline mr-2" + (passwordRequirements.hasDigits ? ' text-success' : '')}></i>
                                            <span>un chiffre (0-9)</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <footer className="block  b-auto-0 pt-5 bg-white mt-auto">

                <Link to={`/auth/referent${location.search}`} className="btn btn-faded px-md-gutter mr-3">Retour</Link>
                {
                    referent.isLoading.includes(loadings.AUTHENTICATING_USERREPRESENTATIVE) ?
                        <button type="button" className="btn btn-info px-4 px-md-gutter loading-btn show"><div className="loading loading-spinner spinner-border spinner-border-sm mr-2"></div>Enregistrer</button>
                        :
                        <button type="button" className="btn btn-info px-4 px-md-gutter" onClick={(e) => {
                            e.preventDefault();
                            if (passwordForm.current.checkValidity() && passwordsMatch === true && passwordRequirements.hasDigits && passwordRequirements.hasLower && passwordRequirements.hasUpper) {
                                dispatch(postUserRepresentativeSelfcareJwt(referent.user.id, password.newPass))
                                    .then(() => window.location = '/facilita');
                            }
                            passwordForm.current.classList.add('was-validated');
                        }}>Enregistrer</button>
                }


            </footer>
        </form>
    );
};